import React, { useState } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Box,
  Button,
  StepperProps,
} from '@mui/material';
import { Form } from 'react-final-form';

type StepperFormProps = {
  steps: {
    label: string;
    component: React.ReactNode;
    validate: (values: any) => object;
  }[];
  onSubmit: (values: any) => void;
} & StepperProps;

const StepperForm: React.FC<StepperFormProps> = ({
  steps,
  onSubmit,
  ...rest
}) => {
  const [activeStep, setActiveStep] = useState(0);
  const [formValues, setFormValues] = useState({});

  const isLastStep = activeStep === steps.length - 1;

  const handleNext = (values: any) => {
    setFormValues({ ...formValues, ...values });
    setActiveStep((prev) => prev + 1);
  };

  const handleFormSubmit = async (values: any) => {
    if (isLastStep) {
      onSubmit({ ...formValues, ...values });
    } else {
      handleNext(values);
    }
  };

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: '16px',
      }}
    >
      <Form
        onSubmit={handleFormSubmit}
        validate={steps[activeStep].validate}
        initialValues={formValues}
        render={({ handleSubmit }) => (
          <form
            onSubmit={handleSubmit}
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '26px',
              }}
            >
              {steps[activeStep].component}
            </Box>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              sx={{ alignSelf: 'flex-end' }}
              fullWidth
            >
              {isLastStep ? 'Create an Account' : 'Continue'}
            </Button>
          </form>
        )}
      />

      <Stepper activeStep={activeStep} {...rest}>
        {steps.map((step, index) => (
          <Step key={index}>
            <StepLabel>{step.label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

export default StepperForm;
